import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "flex flex-col items-center justify-center m-2" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "text-center w-full" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "text-center w-full" }, "マイページに戻る", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseButton = _resolveComponent("BaseButton")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_BaseCard = _resolveComponent("BaseCard")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("img", {
      src: _ctx.landingPageConfig.image_path,
      alt: "landingPageImage",
      class: "my-0 sm:w-6/12 mx-auto"
    }, null, 8, _hoisted_1),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_BaseCard, { class: "sm:w-6/12 text-center p-2" }, {
        default: _withCtx(() => [
          _createElementVNode("p", {
            class: "text-sm",
            innerHTML: _ctx.description
          }, null, 8, _hoisted_3),
          (_ctx.chargeable)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                to: _ctx.receiptChargingLinkTo,
                class: "cursor-pointer"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_BaseButton, {
                    class: "w-4/5 mt-5",
                    buttonClass: "main"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.continuouslyChargingButtonLabel), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["to"]))
            : _createCommentVNode("", true),
          _createVNode(_component_router_link, {
            to: _ctx.mypageLinkTo,
            class: "cursor-pointer"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_BaseButton, {
                class: "w-4/5 mt-5",
                buttonClass: "main"
              }, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["to"])
        ]),
        _: 1
      })
    ])
  ]))
}